import {IDirective, IDirectiveFactory, ILogService, ITimeoutService} from "angular";

export class TextCounter implements IDirective {
    public link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;
    public restrict = "A";
    public scope = {
        model: "=ngModel",
        disabled: "=ngDisabled"
    };

    /* @ngInject */
    public static factory(): IDirectiveFactory {
        const directive: IDirectiveFactory = ($timeout: ITimeoutService, $log: ILogService) => new TextCounter($timeout, $log);
        directive.$inject = ["$timeout", "$log"];
        return directive;
    }

    /* @ngInject */
    constructor(private $timeout: ITimeoutService, private $log: ILogService) {

        TextCounter.prototype.link = (scope: any, elem: any, attrs: ng.IAttributes) => {
            const maxlength = attrs["maxlength"];

            if (maxlength && !scope.disabled) {
                const element: any = document.createElement("div");
                elem[0].parentElement.appendChild(element);
                element.className = "text-counter";
                element.innerHTML = scope.model
                    ? (isNaN(parseInt(scope.model.length, 10))
                    ? "0" : parseInt(scope.model.length, 10)) + "/" + maxlength
                    : "0/" + maxlength;
                elem.bind("keydown, keyup", (event: any) => {
                    $log.debug((parseInt(event.currentTarget.value.length, 10)) + "/" + maxlength);
                    element.innerHTML = parseInt(event.currentTarget.value.length, 10) + "/" + maxlength;
                });
            }
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/text-counter.directive.ts